import { useEffect, type ReactNode } from 'react';
import { useLocation } from 'wouter';
import { useAuth } from '../contexts/AuthContext';
import { DashboardLayout } from './DashboardLayout';
import { PageSpinner } from './ui';

/** Wraps an authenticated page in the dashboard shell; redirects to /login if not signed in. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated, loading } = useAuth();
  const [, navigate] = useLocation();
  useEffect(() => {
    if (!loading && !isAuthenticated) navigate('/login');
  }, [loading, isAuthenticated, navigate]);
  if (loading)
    return (
      <div className="grid min-h-screen place-items-center">
        <PageSpinner />
      </div>
    );
  if (!isAuthenticated) return null;
  return <DashboardLayout>{children}</DashboardLayout>;
}

/** For public pages (login, register, landing): if already signed in, bounce to /overview. */
export function RedirectIfAuthed({ children }: { children: ReactNode }) {
  const { isAuthenticated, loading } = useAuth();
  const [, navigate] = useLocation();
  useEffect(() => {
    if (!loading && isAuthenticated) navigate('/overview');
  }, [loading, isAuthenticated, navigate]);
  if (loading)
    return (
      <div className="grid min-h-screen place-items-center">
        <PageSpinner />
      </div>
    );
  if (isAuthenticated) return null;
  return <>{children}</>;
}
